"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTasksAssignment = useTasksAssignment;
var react_1 = require("react");
var task_1 = require("../features/apis/task");
var api_error_message_1 = require("../utils/api-error-message");
function useTasksAssignment(tasks) {
    var _this = this;
    var _a = (0, react_1.useState)(""), selectedUserId = _a[0], setSelectedUserId = _a[1];
    var _b = (0, react_1.useState)(""), error = _b[0], setError = _b[1];
    var _c = (0, task_1.useAssignTasksMutation)(), assignTasks = _c[0], isBusy = _c[1].isLoading;
    var requestTokenRef = (0, react_1.useRef)(0);
    var requestInFlightRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var isLocked = (0, react_1.useCallback)(function () { return requestInFlightRef.current; }, []);
    var reset = (0, react_1.useCallback)(function () {
        requestTokenRef.current += 1;
        setSelectedUserId("");
        setError("");
    }, []);
    var submit = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, caught_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isBusy || !selectedUserId || tasks.length === 0) {
                        return [2 /*return*/, false];
                    }
                    setError("");
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, assignTasks({ taskIds: tasks.map(function (task) { return task.id; }), assignedUserId: selectedUserId }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/, false];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to assign the selected tasks. Please try again.");
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 3:
                    caught_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/, false];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(caught_1, "Unable to assign the selected tasks. Please try again."));
                    return [2 /*return*/, false];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [assignTasks, isBusy, selectedUserId, tasks]);
    return { selectedUserId: selectedUserId, setSelectedUserId: setSelectedUserId, error: error, isBusy: isBusy, isLocked: isLocked, reset: reset, submit: submit };
}
